import React, { FC, useState } from 'react'
import {
  SwitchPaymentWrapper,
  SwitchModalBackground,
  SwitchModalContainer,
  ClosedModalButton,
} from './style'
import { InvestmentBtn } from 'src/components/Global/Button/Button'
import ExistingCard from '../ExistingCard/ExistingCard'

interface PaymentOption {
  name: 'card' | 'bank'
  type: 'fund' | 'create'
  data: 'new' | string
}

interface SwitchPaymentModalProps {
  showSwitchModal: boolean
  setShowSwitchModal: any
  onClick: (option: PaymentOption) => void
  showBank?: boolean
  plan: any
}

const SwitchPayment: FC<SwitchPaymentModalProps> = ({
  showSwitchModal,
  setShowSwitchModal,
  onClick,
  showBank = true,
  plan,
}: any) => {
  const [option, setOption] = useState<{
    name: 'bank' | 'card'
    data: any
  }>({
    name: 'card',
    data: 'new',
  })

  const handleClose = () => {
    setShowSwitchModal(false)
  }

  const handleClick = (e: any) => {
    e.preventDefault()
    switch (option.name) {
      case 'bank':
        onClick({ name: 'bank', type: 'fund', data: '' })
        break
      default:
        onClick({ name: 'card', data: option.data, type: 'fund' })
        break
    }
    return handleClose()
  }

  const setPaymentOption = (op: 'card' | 'bank' = 'card', data = null) => {
    setOption({
      ...option,
      name: op,
      data,
    })
  }

  const renderButton = () => {
    switch (option.name) {
      case 'bank':
        return (
          <InvestmentBtn onClick={handleClick} className="select_method_btn">
            Bank Transfer{' '}
          </InvestmentBtn>
        )
      case 'card':
        return (
          <InvestmentBtn onClick={handleClick} className="select_method_btn">
            Card{' '}
          </InvestmentBtn>
        )
      default:
        return (
          <InvestmentBtn onClick={handleClick} className="select_method_btn">
            Card{' '}
          </InvestmentBtn>
        )
    }
  }

  const closeModal = () => {
    setShowSwitchModal(false)
  }

  return (
    <SwitchModalContainer>
      {showSwitchModal ? (
        <SwitchModalBackground>
          <SwitchPaymentWrapper>
            <ClosedModalButton onClick={closeModal} size={30} />
            <ExistingCard
              setPaymentOption={setPaymentOption}
              option={option}
              setShowSwitchModal={setShowSwitchModal}
              // handleClick={handleClick}
              // showBankOption={showBank}
            />
            {renderButton()}
          </SwitchPaymentWrapper>
        </SwitchModalBackground>
      ) : null}
    </SwitchModalContainer>
  )
}

export default SwitchPayment
